import { render, staticRenderFns } from "./SummaryStep.vue?vue&type=template&id=21874222&"
import script from "./SummaryStep.vue?vue&type=script&lang=ts&"
export * from "./SummaryStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports